import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", {
  class: "hidden sm:inline-block sm:align-middle sm:h-screen",
  "aria-hidden": "true"
}, "​", -1)
const _hoisted_3 = { class: "inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6" }
const _hoisted_4 = { class: "mt-2 text-center sm:mt-5" }
const _hoisted_5 = { class: "mt-3 flex flex-col gap-y-4" }
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "" }
const _hoisted_9 = { class: "mt-5 sm:mt-6 text-center" }

import { computed, inject, onMounted, ref, watch } from "vue";
import {
  Dialog,
  DialogTitle,
  DialogOverlay,
  TransitionRoot,
  TransitionChild,
  Switch,
} from "@headlessui/vue";
import { AxiosInstance } from "axios";
import DropdownComponent from "../tools/DropdownComponent.vue";
import { useStore } from "vuex";
import { translate } from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'LoyaltyRedemptionShipDialog',
  props: { form: Object, show: Boolean },
  emits: ["submit", "update:show", "update:form", "ship"],
  setup(__props, { emit }) {

const props = __props

const axios = inject("$axios") as AxiosInstance;
const store = useStore();
const options = ref([
  { label: translate("messages.rewardRedemption.pending"), value: "PENDING" },
  {
    label: translate("messages.rewardRedemption.completed"),
    value: "COMPLETED",
  },
]);
const statusOptions = ref([
  {
    label: translate("messages.rewardRedemption.waitForApprove"),
    value: "WAIT_FOR_APPROVED",
  },
  {
    label: translate("messages.rewardRedemption.approved"),
    value: "APPROVED",
  },
  {
    label: translate("messages.rewardRedemption.rejected"),
    value: "REJECTED",
  },
]);
const selectedSync = ref({
  label: "",
  value: "",
});
const isRefund = ref(false);
const selectedStatus = ref({
  label: translate("messages.rewardRedemption.selectStatus"),
  value: "SELECT STATUS",
});
const approvedBy = ref({
  id: "",
  name: "",
});
const showSync = computed({
  get: () => props.show,
  set: (value) => emit("update:show", value),
});
const trackingNumberSync = ref();
const trackingLinkSync = ref();
const onSelectedStatus = (e: any) => (selectedStatus.value = e);

const onClose = async () => {
  trackingNumberSync.value = "";
  trackingLinkSync.value = "";
  showSync.value = false;
};

const updateShipment = async () => {
  try {
    const payload = {
      id: props.form?.id,
      trackingNo: trackingNumberSync.value,
      trackingLink: trackingLinkSync.value,
    };
    await axios.put(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/shipment/update-tracking`,
      payload
    );
  } catch (error) {
    console.log(error);
  }
};
const updateStatus = async () => {
  try {
    const payload = {
      id: props.form?.id,
      trackingNo: trackingNumberSync.value,
      trackingLink: trackingLinkSync.value,
      status: selectedStatus.value.value,
      isRefund: selectedStatus.value.value === "REJECTED",
      approvedByUserId: store.state.user.id,
      approvedByUsername: store.state.user.username,
    };

    await axios.put(`${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/loyalty/api/internal/shipment/update`,
      payload
    );
  } catch (error) {
    console.log(error);
  }
};

const onShip = async () => {
  props.form?.status === "WAIT_FOR_APPROVED"
    ? await updateStatus()
    : await updateShipment();
  emit("ship");
  showSync.value = false;
};

watch(isRefund, (val) => {
  if (val) {
    selectedStatus.value = {
      label: "REJECTED",
      value: "REJECTED",
    };
  }
});

watch(selectedStatus, (val) => {
  if (val.label === "REJECTED") {
    isRefund.value = true;
  }
});

watch(showSync, (val) => {
  if (val && props.form) {
    trackingLinkSync.value = props.form.trackingLink;
    trackingNumberSync.value = props.form.trackingNo;
    selectedStatus.value = {
      label: props.form.status,
      value: props.form.status,
    };
    selectedSync.value = {
      label: props.form.status,
      value: props.form.status,
    };
    approvedBy.value = {
      id: props.form.userId,
      name: props.form.username,
    };
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: _unref(showSync)
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        static: "",
        class: "fixed z-10 inset-0 overflow-y-auto",
        onClose: _cache[4] || (_cache[4] = ($event: any) => (showSync.value = false)),
        open: _unref(showSync)
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" })
              ]),
              _: 1
            }),
            _hoisted_2,
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "ease-out duration-300",
              "enter-from": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95",
              "enter-to": "opacity-100 translate-y-0 sm:scale-100",
              leave: "ease-in duration-200",
              "leave-from": "opacity-100 translate-y-0 sm:scale-100",
              "leave-to": "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(DialogTitle), {
                        as: "h3",
                        class: "text-lg leading-6 font-medium text-gray-900"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("messages.rewardRedemption.rewardShipment")), 1)
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: 
                        _ctx.$t('messages.rewardRedemption.trackingNumber')
                      ,
                            min: "0",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((trackingNumberSync).value = $event)),
                            class: "rounded w-full"
                          }, null, 8, _hoisted_6), [
                            [_vModelText, trackingNumberSync.value]
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: 
                        _ctx.$t('messages.rewardRedemption.trackingLink')
                      ,
                            min: "0",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((trackingLinkSync).value = $event)),
                            class: "rounded w-full"
                          }, null, 8, _hoisted_7), [
                            [_vModelText, trackingLinkSync.value]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(DropdownComponent, {
                            class: "w-full",
                            "is-disable": props.form?.status !== 'WAIT_FOR_APPROVED',
                            options: statusOptions.value,
                            modelValue: selectedStatus.value,
                            onOnOptionSelected: onSelectedStatus
                          }, null, 8, ["is-disable", "options", "modelValue"])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (onClose())),
                      class: "mt-3 mr-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, " close "),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (onShip())),
                      class: "mt-3 ml-2 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-blue-400 text-base font-medium text-white hover:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                    }, " Update ")
                  ])
                ])
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["open"])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})